const UserSettingStructure = {
    userid: "",
    useruuid: "",
    username: "",
    userimageurl: "",
    feedviewmode: "",
    sortorder: "",
    globaltheme: "",
    perprofiletheme: false,
    perprofiledisplaymode: false,
    globaldisplaymode: "",
    issubscribed: "",
    currentpassword: "",
    mobnumber: "",
    location: "",
    profiles: [
        {
            profileid: "",
            profileuuid: "",
            profiletype: "",
            profileimageurl: "",
            profiletheme: "",
            profiledisplaymode: "",
        }
    ],
    parentalcontrol: false,
    dateofbirth: "",
    naccountwithpc: 0,
    accountstatus: "",
    accounttype: "",
};

export default UserSettingStructure;
